import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const reveal = {
  initial: { opacity: 0, y: 40 }, whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: "-80px" },
  transition: { duration: 0.9, ease: [0.16, 1, 0.3, 1] },
};

const CAMPAIGNS = [
  { title: "The Art of Control", client: "Genesis · Editorial", cat: "Brand Film · Photography · Magazine", img: "https://images.unsplash.com/photo-1610374634235-b51ef357f905?w=1600&q=85" },
  { title: "Ditch the Screens", client: "Scouts Canada", cat: "Cross-Channel Campaign", img: "https://images.unsplash.com/photo-1503676260728-1c00da094a0b?w=1600&q=85", to: "/impact/ditch-the-screens" },
  { title: "Giving Tuesday", client: "Raise Chess Academy", cat: "Fundraising Campaign", img: "https://images.pexels.com/photos/163064/play-stone-network-networked-interactive-163064.jpeg?w=1600", to: "/impact/giving-tuesday" },
  { title: "Nocturne · Issue 01", client: "Good Bandit", cat: "Editorial Publication", img: "https://images.unsplash.com/photo-1623346483743-b968a27ed34c?w=1600&q=85", to: "/nocturne" },
];

export default function Campaigns() {
  return (
    <main data-testid="campaigns-page" className="bg-black pt-32 pb-8">
      <section className="max-w-[1600px] mx-auto px-6 md:px-12 lg:px-16 mb-16">
        <motion.p {...reveal} className="overline mb-6">Work · Campaigns</motion.p>
        <motion.h1 {...reveal} className="font-display text-6xl md:text-8xl text-white leading-[0.95]">
          Campaigns <span className="italic text-[var(--gb-gold)]">/</span> Integrated
        </motion.h1>
        <motion.p {...reveal} className="text-white/65 text-base md:text-lg max-w-2xl mt-10 leading-relaxed">
          Integrated creative programs across film, photography, print, digital and
          social. Built to move audiences, not just impressions.
        </motion.p>
      </section>

      <section className="max-w-[1600px] mx-auto px-6 md:px-12 lg:px-16 grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
        {CAMPAIGNS.map((c, i) => {
          const inner = (
            <div className="group relative aspect-[16/10] overflow-hidden bg-[#0a0a0a]">
              <img src={c.img} alt={c.title} className="absolute inset-0 w-full h-full object-cover opacity-75 group-hover:opacity-90 group-hover:scale-[1.02] transition-all duration-[1200ms] ease-[cubic-bezier(0.16,1,0.3,1)]" />
              <div className="absolute inset-0 bg-gradient-to-t from-black via-black/40 to-transparent" />
              <div className="absolute inset-0 flex flex-col justify-between p-8 md:p-10">
                <p className="kbd text-[var(--gb-gold)]">0{i + 1}</p>
                <div>
                  <p className="kbd text-white/50 mb-2">{c.client}</p>
                  <h2 className="font-display text-3xl md:text-5xl text-white leading-tight group-hover:text-[var(--gb-gold)] transition-colors duration-500">{c.title}</h2>
                  <p className="text-white/55 text-sm mt-3">{c.cat}</p>
                </div>
              </div>
            </div>
          );
          return c.to ? (
            <motion.div {...reveal} key={i}>
              <Link to={c.to} data-testid={`campaign-${i}`}>{inner}</Link>
            </motion.div>
          ) : (
            <motion.div {...reveal} key={i} data-testid={`campaign-${i}`}>{inner}</motion.div>
          );
        })}
      </section>
    </main>
  );
}
